export const ORIENTATION = Object.freeze({
  portrait: 'portrait',
  landscape: 'landscape',
});

export type Orientation = keyof typeof ORIENTATION;

export const getOrientation = (): Orientation => (
  window.matchMedia('(orientation: portrait)').matches ? ORIENTATION.portrait : ORIENTATION.landscape
);

export const isOrientationPortrait = (orientation: Orientation) => orientation === ORIENTATION.portrait;

export const isOrientationLandscape = (orientation: Orientation) => orientation === ORIENTATION.landscape;
